import { useContext } from 'react';

import { TagsContext } from '../../contexts/TagsContext';

export const useTags = () => {
  const context = useContext(TagsContext);
  if (context === undefined) {
    throw new Error('useTags must be used within an TagsProvider');
  }
  return context;
};
